import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LayoutState } from './layout.reducer';

export const selectLayoutState = createFeatureSelector<LayoutState>('layout');

export const selectLoaderMessage = createSelector(
  selectLayoutState,
  layoutState => layoutState && layoutState.message && layoutState.message[0],
);

export const selectIsLoading = createSelector(selectLayoutState, layoutState => layoutState.isLoading);
